export const GET_CASE_SUCCESS ='GET_CASE_SUCCESS';
export const GET_CASE_FAILURE ='GET_CASE_FAILURE';


//Actions
export const getCaseSuccess=(value)=>{
    return {
        type: GET_CASE_SUCCESS,
        payload: value
    }
}

export const getCaseFailure=(value)=>{
    return {
        type: GET_CASE_FAILURE,
        payload: value
    }
}

